import { ListItem, SideList } from '@/components/Ui';

interface ListItemData {
  _id: string;
  name: string;
}

interface TopicsListProps<T extends ListItemData> {
  showBtn?: boolean;
  items: T[];
  isLoading?: boolean;
  onItemClick: (item: T) => void;
  selectedItemId?: string;
  btnTitle?: string;
  onAddClick?: () => void;
  optionalBtn?: boolean;
  optionalBtnTitle?: string;
  optionalBtnOnClick?: () => void;
}

const TopicsList = <T extends ListItemData>({
  showBtn = true,
  items = [],
  isLoading = false,
  onItemClick,
  selectedItemId,
  btnTitle = 'Ajouter une matière',
  onAddClick,
  optionalBtn,
  optionalBtnTitle,
  optionalBtnOnClick,
}: TopicsListProps<T>) => {
  return (
    <SideList
      isLoading={isLoading}
      btnTitle={btnTitle}
      addBtn={onAddClick}
      showBtn={showBtn}
      optionalBtn={optionalBtn}
      optionalBtnTitle={optionalBtnTitle}
      optionalBtnOnClick={optionalBtnOnClick}
    >
      {isLoading ? (
        <div className="text-white h-10 flex items-center justify-center">
          Chargement...
        </div>
      ) : (
        items?.map((item) => {
          const isSelected = item._id === selectedItemId;
          return (
            <div
              key={item._id}
              onClick={() => onItemClick(item)}
              className="pl-2"
            >
              <ListItem
                focused={isSelected}
                leftBorderColor={isSelected ? '#FEC200' : '#131311'}
                listItemStyle={`w-full relative before:content-[''] before:absolute before:w-full before:h-[1px] before:bg-[#2D2D2C] before:bottom-[0px] before:left-[0px] border-l-[transparent] ${
                  isSelected ? 'bg-[#131311]' : 'bg-transparent'
                }`}
              >
                <p>{item.name}</p>
              </ListItem>
            </div>
          );
        })
      )}
    </SideList>
  );
};

export default TopicsList;
